import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { BOSS } from '../partials/store/BOSS';
import { InStock } from '../partials/store/InStock';
import { InStockNearby } from '../partials/store/InStockNearby';
import { LimitedAvailability } from '../partials/store/LimitedAvailability';
import { LimitedAvailabilityNearby } from '../partials/store/LimitedAvailabilityNearby';
import { LimitedAvailabilityInStockNearby } from '../partials/store/LimitedAvailabilityInStockNearby';
import { NotLocalized } from '../partials/store/NotLocalized';
import { NoStoreOption } from '../partials/store/NoStoreOption';
import { LiveGoodsMessaging } from '../partials/store/LiveGoodsMessaging';
import { BopisOffMessage } from '../partials/store/BopisOffMessage';

import {
  getSellableQuantityYourStore,
  // getStoreStatus,
  // hasZeroStock,
  isBOPIS,
  isBOSS,
  isBrowseOnly,
  isShared,
  // isCurrentlyUnavailable,
  isDiscontinued,
  // isInStock,
  isLimitedStock,
  isInStockYourStore,
  isInStockNearby,
  isLimitedStockNearby,
  isOutOfStockYourStore,
  isLiveGoods
} from './pod-fulfillment-utils';

export const getStoreTemplate = ({ product, storeId }) => {

  if (isLiveGoods(product)) {
    const qty = getSellableQuantityYourStore(product);
    if (!qty) { return LiveGoodsMessaging; }
    if (qty > 0) { return InStock; }
  }

  if (storeId) {
    /* -----Browse Only----- */
    if (isBrowseOnly(product)) {
      /* Browse only, Non purchasable online and store must be purchased in store */
      // @TODO: What is getStoreStatus 400? Test in stage with 304384882.
      // if (getStoreStatus(sku) === 400) {
      //   return NoStoreOption;
      // }
      if (isBOPIS(product)) {
        return BopisOffMessage;
      }
      return LimitedAvailability;
    }

    /* -----BOPIS----- */
    if (isBOPIS(product)) {
      if (isShared(product)) { return BopisOffMessage; }
      if (isLimitedStock(product) && isInStockNearby(product)) {
        return LimitedAvailabilityInStockNearby;
      }
      if (isLimitedStock(product)) { return LimitedAvailability; }
      if (isLimitedStockNearby(product)) { return LimitedAvailabilityNearby; }
      if (isInStockYourStore(product)) { return InStock; }
      if (isInStockNearby(product)) { return InStockNearby; }
    }

    /* -----BOSS----- */
    if (isBOSS(product)) {
      return BOSS;
    }

    /* -----No BOSS or BOPIS----- */
    return () => {
      // @TODO: What is in stock?
      // if (isInStock(product) || hasZeroStock(product) || isLimitedStock(product)) {
      //   /* Not BOPIS but has qtyForSale */
      //   return <LimitedAvailability localizedStore={localizedStore} channel={channel} />;
      // }
      if (isDiscontinued(product)) {
        return null;
      }
      if (isOutOfStockYourStore(product)) {
        return (
          <NoStoreOption
            storeMessage="Out of stock at your store"
            enableNearbyStore
            product={product}
          />
        );
      }
      if (product?.availabilityType?.type === 'Shared') {
        return (
          <NoStoreOption
            storeMessage="Unavailable at your store"
            enableNearbyStore
            product={product}
          />
        );
      }
      /* Not Sold in Stores */
      return <NoStoreOption storeMessage="Not sold in stores" enableNearbyStore={false} />;
    };
  }
  return NotLocalized;
};
